import Simulator from '../components/personas/Simulator';
import SimulaTuCreditoDesc from '../components/personas/CDTs/SimulaTuCreditoDesc';
import Carousel from '../components/Carousel2';
import FAQSection from '../components/personas/CDTs/FAQ';

function SimulaTuFIC() {
    return (
        <div>
            <Simulator titulo="Simula tu FIC" tipo="FIC" />
            <SimulaTuCreditoDesc />
            <Carousel />
            <FAQSection />
            <hr className="w-full border-t border-black" />
        </div>
    );
}
export default SimulaTuFIC;
